export const css = {
	oneaction: '_3OM5ZRx2',
	' _key': 'certwise-theme/certwise/quiz-widgets/flashcard'
};

export default css;
